// ══════════════════════════════════════════════════════════════════════
// 💬 KALICI SOHBET DÜZENİ
// ══════════════════════════════════════════════════════════════════════
// SORUN: LiveChat 21 ayrı sayfada tek tek mount ediliyordu. React Router'da
// sayfa değişince o ağaç SÖKÜLÜP yeniden kuruluyor, yani her gezinmede:
//   • WebSocket (/ws/chat) kopuyor ve yeniden bağlanıyor
//   • 4 HTTP isteği tekrar atılıyor (messages, rain/state, system-message, online)
// Kullanıcı sekmeler arasında dolaştıkça bu sunucuya sürekli gereksiz yük
// bindiriyor ve sohbet her seferinde baştan yükleniyordu.
//
// ÇÖZÜM: LiveChat App.js'te <Routes> DIŞINDA tek kez render edilir. Router
// yalnızca <Routes> içindeki ağacı değiştirdiği için sohbet HİÇ sökülmez;
// soket ve mesaj geçmişi ayakta kalır.
//
// Sayfalar sohbetin genişliği kadar iç boşluk bırakmak zorunda olduğundan
// (aç/kapa durumuna göre), o durum burada paylaşılır.
import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const ChatLayoutContext = createContext(null);

export const useChatLayout = () => {
  const ctx = useContext(ChatLayoutContext);
  // ⚠️ Provider yoksa ÇÖKMEZ: sohbeti hiç kullanmayan bir sayfa (ör. login)
  // provider dışında render edilirse hata yerine "kapalı" varsayılır.
  return ctx || { chatOpen: false, setChatOpen: () => {}, toggleChat: () => {}, padClass: '' };
};

// Sayfa içeriğinin sohbete çarpmaması için bırakılan boşluk.
// ⚠️ Tüm sayfalarda AYNI olmalı; tek yerden yönetiliyor.
export const CHAT_PAD_CLASS = 'md:pl-[340px] lg:pl-[370px]';

export const ChatLayoutProvider = ({ children }) => {
  // ⚠️ MOBİLDE KAPALI BAŞLAR. Dar ekranda sohbet içeriğin üstünü kaplıyor;
  // açık başlatmak kullanıcıyı her girişte kapatmaya zorlardı.
  const [chatOpen, setChatOpen] = useState(
    () => (typeof window === 'undefined' ? true : window.innerWidth >= 768)
  );
  const toggleChat = useCallback(() => setChatOpen(o => !o), []);

  // ⚠️ HEADER'IN MOBİL SOHBET DÜĞMESİ ARTIK HER SAYFADA ÇALIŞIR.
  // Bu dinleyici eskiden YALNIZCA Home.js içindeydi; kullanıcı başka bir
  // sayfadayken düğmeye bastığında hiçbir şey olmuyordu. Sohbet tek yere
  // taşındığı için dinleyici de tek yere taşındı.
  React.useEffect(() => {
    const onToggle = () => setChatOpen(o => !o);
    window.addEventListener('toggleMobileChat', onToggle);
    return () => window.removeEventListener('toggleMobileChat', onToggle);
  }, []);
  const value = useMemo(() => ({
    chatOpen, setChatOpen, toggleChat,
    // Sayfaların doğrudan kullanabileceği hazır sınıf.
    padClass: chatOpen ? CHAT_PAD_CLASS : '',
  }), [chatOpen, toggleChat]);
  return <ChatLayoutContext.Provider value={value}>{children}</ChatLayoutContext.Provider>;
};
